import React, { Component } from 'react'
import '../../assets/css/tor-template-list.css'

class ReportPDFScreen extends Component {

    constructor (props) {
        super(props)
        this.state = {
            
        }
    }

    render() {
        return (
            
            <div className="tor tor-template-list">  
                <div id="main-content">
                    <div className="sp-page-report-panel row">
                        <div id="pdf_data">
                            <div id="report-header" className="sp-page-report-header-panel row">
                                <div style={{marginBottom: '200px'}}></div>
                            </div>
                            <div id="report_body" >
                            <div className="sp-page-report-body-panel row">
                                <div>
                                    <div style={{marginBottom: '80px'}}>
                                        <p style={{fontSize: '14pt', textIndent: '100px'}}>ที่ { this.props.requisitioner }/{ this.props.moM_DOC_NO }</p>
                                    </div>
                                    <div style={{marginBottom: '80px'}}>
                                        <center><p style={{fontSize: '18pt'}}><b>ใบตรวจรับพัสดุ</b></p></center>
                                    </div>
                                    <div style={{marginBottom: '80px'}}>
                                        <center><p style={{fontSize: '14pt'}}>{ this.props.moM_DATE }</p></center>
                                    </div>
                                    <div style={{marginBottom: '30px'}}>
                                        <p style={{fontSize: '14pt', textIndent: '100px'}}>ตามหนังสือสัญญา/ข้อตกลง/ใบสั่ง เลขที่ {this.props.pO_CONTRACT_NO} ลงวันที่ {this.props.pO_DATE} บริษัท ปตท. จำกัด (มหาชน) ได้ตกลง</p>
                                        <p style={{fontSize: '14pt'}}>จัดซื้อจัดจ้างกับ {this.props.vendoR_NAME} สำหรับ{this.props.headeR_TEXT} นั้น </p>
                                    </div>
                                    <div style={{marginBottom: '30px'}}>
                                        <p style={{fontSize: '14pt', textIndent: '100px'}}>คู่สัญญาได้ส่งมอบ {this.props.headeR_TEXT} งวดที่ {this.props.installmenT_NO_MR} เมื่อวันที่ {this.props.completeD_DATE}</p>
                                        <p style={{fontSize: '14pt'}}>ซึ่งคณะกรรมการตรวจรับได้ประชุมพิจารณาตรวจรับแล้ว ผลปรากฏว่า</p>
                                    </div>
                                    <div style={{marginBottom: '30px'}}>
                                        <p style={{fontSize: '14pt', textIndent: '100px'}}>ผลการตรวจรับ</p>
                                    </div>
                                    <div style={{marginBottom: '30px'}}>
                                        <p style={{fontSize: '14pt', textIndent: '100px'}}><input type="checkbox" id="" name="" checked></input>ถูกต้อง</p>
                                        <p style={{fontSize: '14pt', textIndent: '130px'}}><input type="checkbox" id="" name="" checked></input>ครบถ้วนตามสัญญา</p>
                                        <p style={{fontSize: '14pt', textIndent: '130px'}}><input type="checkbox" id="" name=""></input>ไม่ครบถ้วนตามสัญญา</p>
                                    </div>
                                    <div style={{marginBottom: '50px'}}>
                                        <p style={{fontSize: '14pt', textIndent: '100px'}}>ค่าปรับ</p>
                                        <p style={{fontSize: '14pt', textIndent: '130px'}}><input type="checkbox" id="" name="" checked={ this.props.penaltY_AMOUNT > 0 ? true : false }></input>มีค่าปรับ</p>
                                        <p style={{fontSize: '14pt', textIndent: '130px'}}><input type="checkbox" id="" name="" checked={ this.props.penaltY_AMOUNT == 0 ? true : false  }></input>ไม่มีค่าปรับ</p>
                                    </div>
                                    <div style={{marginBottom: '80px', marginLeft: '250px'}}>
                                        <center><p style={{fontSize: '14pt'}}>คณะกรรมการตรวจรับพัสดุ</p></center>
                                        <br></br>
                                        <br></br>
                                        <center><p style={{fontSize: '14pt'}}>{this.props.headeR_TEXT}</p></center>
                                    </div>
                                    <div>
                                    <p style={{fontSize: '12pt', textIndent: '100px'}}>Electronically approved by Acceptance Committee</p>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div id="report-footer" className="sp-page-report-footer-panel row">
                                <div style={{marginBottom: '50px'}}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default ReportPDFScreen